import SVGIconWrapper from "./SVGIconWrapper"

const IconBudget = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="18 18 64 64"
        iconClass={`icon--budget ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M62,20H38a.89.89,0,0,0-.87.88v2.91a.89.89,0,0,0,.87.88H62a.9.9,0,0,0,.87-.88V20.88A.9.9,0,0,0,62,20Z"/>
        <path d="M43.29,27H38a.89.89,0,0,0-.87.88v1.74a.89.89,0,0,0,.87.88h5.25a.9.9,0,0,0,.88-.88V27.88A.9.9,0,0,0,43.29,27Z"/>
        <path d="M52.62,27H47.38a.9.9,0,0,0-.88.88v1.74a.9.9,0,0,0,.88.88h5.24a.9.9,0,0,0,.88-.88V27.88A.9.9,0,0,0,52.62,27Z"/>
        <path d="M62,27H56.71a.9.9,0,0,0-.88.88v1.74a.9.9,0,0,0,.88.88H62a.9.9,0,0,0,.87-.88V27.88A.9.9,0,0,0,62,27Z"/>
        <path d="M43.29,32.83H38a.89.89,0,0,0-.87.88v1.75a.89.89,0,0,0,.87.87h5.25a.9.9,0,0,0,.88-.87V33.71A.9.9,0,0,0,43.29,32.83Z"/>
        <path d="M52.62,32.83H47.38a.9.9,0,0,0-.88.88v1.75a.9.9,0,0,0,.88.87h5.24a.9.9,0,0,0,.88-.87V33.71A.9.9,0,0,0,52.62,32.83Z"/>
        <path d="M62,32.83H56.71a.9.9,0,0,0-.88.88v1.75a.9.9,0,0,0,.88.87H62a.9.9,0,0,0,.87-.87V33.71A.9.9,0,0,0,62,32.83Z"/>
        <path d="M43.29,38.67H38a.89.89,0,0,0-.87.87v1.75a.89.89,0,0,0,.87.88h5.25a.9.9,0,0,0,.88-.88V39.54A.9.9,0,0,0,43.29,38.67Z"/>
        <path d="M52.62,38.67H47.38a.9.9,0,0,0-.88.87v1.75a.9.9,0,0,0,.88.88h5.24a.9.9,0,0,0,.88-.88V39.54A.9.9,0,0,0,52.62,38.67Z"/>
        <path d="M62,38.67H56.71a.9.9,0,0,0-.88.87v1.75a.9.9,0,0,0,.88.88H62a.9.9,0,0,0,.87-.88V39.54A.9.9,0,0,0,62,38.67Z"/>
        <path d="M43.29,44.5H38a.89.89,0,0,0-.87.88v1.75A.89.89,0,0,0,38,48h5.25a.9.9,0,0,0,.88-.87V45.38A.9.9,0,0,0,43.29,44.5Z"/>
        <path d="M52.62,44.5H47.38a.9.9,0,0,0-.88.88v1.75a.9.9,0,0,0,.88.87h5.24a.9.9,0,0,0,.88-.87V45.38A.9.9,0,0,0,52.62,44.5Z"/>
        <path d="M62,44.5H56.71a.9.9,0,0,0-.88.88v1.75a.9.9,0,0,0,.88.87H62a.9.9,0,0,0,.87-.87V45.38A.9.9,0,0,0,62,44.5Z"/>
        <path d="M75.11,57.45H51.5V52.13a1.5,1.5,0,1,0-3,0v5.32H24.89a1.5,1.5,0,0,0-1.5,1.5v7.86a1.5,1.5,0,0,0,3,0V60.45H48.5v5.16a1.5,1.5,0,0,0,3,0V60.45H73.61v6.36a1.5,1.5,0,0,0,3,0V59A1.5,1.5,0,0,0,75.11,57.45Z"/>
        <circle cx="24.89" cy="74.71" r="4.89"/>
        <circle cx="49.82" cy="74.71" r="4.89"/>
        <circle cx="75.11" cy="74.71" r="4.89"/>
    </SVGIconWrapper>
)

export default IconBudget